<template>
  <div class="featured-items featured-items--recipes">
    <h2>
      Featured Recipes
    </h2>
    <div v-if="debugging">
      Total: {{ recipeCount.total }}<br>
      Current: {{ recipeCount.current }}<br>
      Per Page: {{ recipeCount.perPage }}<br>
      Page: {{ recipeCount.page }}<br>
      Next: {{ recipeCount.next }}<br><br>
      Count: {{ count }}<br><br>
      Recipes so far: {{ recipesSoFar }}
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
    >
      <defs>
        <pattern
          id="pattern_xAU1k"
          patternUnits="userSpaceOnUse"
          width="9.5"
          height="9.5"
          patternTransform="rotate(45)"
        >
          <line
            x1="0"
            y="0"
            x2="0"
            y2="9.5"
            stroke="#3A8479"
            stroke-width="9"
          />
        </pattern>
      </defs>
    </svg>
    <ul>
      <template v-for="(recipe, index) in filteredItems">
        <li
          v-if="index < recipesSoFar"
          :key="index"
        >
          <Recipe
            :recipe="recipe"
          />
        </li>
      </template>
    </ul>
    <div class="view-more-container">
      <button
        v-if="recipeCount.current > recipesSoFar"
        class="button"
        @click="addMoreTrends"
      >
        Load More
      </button>
    </div>
  </div>
</template>

<script>
    import Recipe from "./items/Recipe.vue"

    import store from "../store"

    export default {
        name: "RecipesView",
        components: {
            Recipe
        },
        props: {
          page: {
            type: Number,
            required: false,
            default: null
          },
        },
        data() {
          return {
            recipeCount: {
              current: 0,
              total: 0,
              perPage: 12,
              page: 1,
              next: 0
            },
            activeFilters: [],
            debugging: false
          }
        },
        computed: {
          filteredItems: function() {
            return store.state.items.filter(i => {
              // console.log(i);
              return !i.isExcluded;
            })
          },
          count: function() {
            return this.filteredItems.length;
          },
          recipesLeft: function() {
            return this.recipeCount.current - (this.recipeCount.perPage * this.recipeCount.page)
          },
          recipesSoFar: function() {
            return this.recipeCount.perPage * this.recipeCount.page
          },
          sectionTitle: function() {
            return window.listTitleOverride
          },
           filterCategories: function() {
            var categories = [];
            this.$store.state.filters.map(f => {
              if(f.selected == true){
                categories.push(f.name);
              }
            })
            // console.log('this.$store.state', this.$store.state)
            return categories;
          }
        },
        updated() {
          this.updateCounts()
        },
          mounted() {
          if(this.page){
            this.recipeCount.page = this.page
          }
        },
        created() {
          // this.productCount.total = this.count
          // this.productCount.current = this.count
          // this.productCount.next = (this.productCount.current >= this.productCount.perPage * (this.productCount.page + 1)) ? this.productCount.perPage : this.productCount.current - (this.productCount.perPage * this.productCount.page)
          this.updateCounts()

        },
        methods: {
          updateCounts: function() {
            // console.log('updateCounts')
            this.recipeCount.total = this.count
            this.recipeCount.current = this.count
            this.recipeCount.next = (this.recipeCount.current >= this.recipeCount.perPage * (this.recipeCount.page + 1)) ? this.recipeCount.perPage : this.recipeCount.current - (this.recipeCount.perPage * this.recipeCount.page)
            this.$emit('updateCount', this.count)
          },

          filteredTrends: function() {
              //console.log(this.$store.state.items);
              return this.$store.state.items.filter(function(item) {
                  return !item.isExcluded;
              });
          },
          addMoreTrends: function() {
            ++this.recipeCount.page
            // this.productCount.current = this.productCount.current + this.productCount.perPage
            // eslint-disable-next-line
            if (typeof dataLayer === 'object') {
              // eslint-disable-next-line
              dataLayer.push({
                event: 'genericEvent',
                eventCat: 'product engagement',
                eventAction: 'button click',
                eventLabel: 'View More Products',
              });
            }
            this.$router.push({path: this.$route.path, query: { page: this.recipeCount.page }})
          },
          incrementCounter: function(trend) {
            if (!trend.isExcluded) {
              this.liveCounter++
            }
            // console.log('liveCounter', this.liveCounter)
          },
          updateFilters: function(filt) {

            this.$store.dispatch('applyFilters', filt.target)
            let action = 'select off'
            let label = filt
            // eslint-disable-next-line
            if (typeof dataLayer === 'object') {
              // eslint-disable-next-line
              dataLayer.push({
                event: 'genericEvent',
                eventCat: this.view + ' filter',
                eventAction: action,
                eventLabel: label,
              });
            }
         }
        }
    };
</script>
